module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("\n    Table of Contents\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781611532630#_idParaDest-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/97816115326301#_idParaDest-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TOC"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/97816115326302#_idParaDest-3"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/97816115326303#_idParaDest-4"
    }
  }, [_vm._v("Infamous")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/97816115326304#_idParaDest-5"
    }
  }, [_vm._v("chapter 1 Iowa")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/97816115326305#_idParaDest-6"
    }
  }, [_vm._v("chapter 2 Sunshine")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/97816115326306#_idParaDest-7"
    }
  }, [_vm._v("chapter 3 Bur Oak")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/97816115326307#_idParaDest-8"
    }
  }, [_vm._v("chapter 4 New Year’s Eve")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/97816115326308#_idParaDest-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5 Fayetteville or Bust")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/97816115326309#_idParaDest-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 6 M.A. Hopkins")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263010#_idParaDest-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 7 First Day")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263011#_idParaDest-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 8 Go-Kart")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263012#_idParaDest-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 9 Converging Coordinate Planes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263013#_idParaDest-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 10 Stenos and Strippers")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263014#_idParaDest-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 11 Apologies")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263015#_idParaDest-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 12 Blond Hair, Blue Eyes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263016#_idParaDest-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 13 Sizzle")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263017#_idParaDest-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 14 Steppin’ Out")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263018#_idParaDest-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15 Hair Apparent")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263019#_idParaDest-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16 Hindsight")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263020#_idParaDest-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 17 Infamous")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263021#_idParaDest-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 18 Check Canopy")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263022#_idParaDest-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 19 Kings and Queens")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263023#_idParaDest-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 20 Corn Rows")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263024#_idParaDest-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 21 Purple Coneflower Boutonniere")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263025#_idParaDest-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 22 Smothered and Covered")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263026#_idParaDest-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 23 Heathcliff and Catherine")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263027#_idParaDest-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 24 Zugzwang")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263028#_idParaDest-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 25 Soul Food")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263029#_idParaDest-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 26 Coming and Going")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263030#_idParaDest-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 27 Let Freedom Ring")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263031#_idParaDest-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 28 Promises, Promises")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263032#_idParaDest-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29 Love Makes the World Go ‘Round")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263033#_idParaDest-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30 Unexpected Visitor")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263034#_idParaDest-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31 Goodbyes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263035#_idParaDest-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32 New Beginnings")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263036#_idParaDest-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note to Readers from Amalie Jahn")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263037#_idParaDest-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263038#_idParaDest-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/978161153263039#_idParaDest-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If You Liked This Book You Might Also Like")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 63
// module chunks = 0